import cloneDeep from 'lodash/cloneDeep'
import { ADD_SQUAD_MEMBERS, DELETE_SQUAD_MEMBERS } from '../../actions/game/squad.actions'

const initialState = []

const squadReducer = (state = initialState, action) => {
    const { payload } = action

    switch (action.type) {
        case ADD_SQUAD_MEMBERS: {
            const { units } = payload
            return [
                ...cloneDeep(state),
                ...units,
            ]
        }

        case DELETE_SQUAD_MEMBERS: {
            const { units } = payload
            return cloneDeep(state).filter(member => !units.includes(member))
        }

        default: {
            return state
        }
    }
}

export default squadReducer
